export const techStack = {
  frontend: [
    'HTML5',
    'CSS3',
    'JavaScript',
    'React.js',
    'Tailwind CSS',
    'Bootstrap',
    'Responsive Design'
  ],
  backend: [
    'Node.js',
    'Express.js',
    'Python',
    'Java',
    'RESTful APIs',
    'GraphQL'
  ],
  database: [
    'MongoDB',
    'MySQL',
    'PostgreSQL',
    'Firebase'
  ],
  tools: [
    'Git',
    'GitHub',
    'UiPath',
    'Postman',
    'VS Code',
    'Docker',
    'AWS'
  ],
  languages: [
    'Python',
    'Java',
    'C',
    'C++',
    'JavaScript',
    'TypeScript'
  ]
};

export const skillCategories = [
  {
    name: 'Frontend',
    icon: 'Code',
    color: 'blue',
    skills: techStack.frontend
  },
  {
    name: 'Backend',
    icon: 'Server',
    color: 'green',
    skills: techStack.backend
  },
  {
    name: 'Database',
    icon: 'Database',
    color: 'purple',
    skills: techStack.database
  },
  {
    name: 'Tools',
    icon: 'Tool',
    color: 'orange',
    skills: techStack.tools
  },
  {
    name: 'Languages',
    icon: 'Code',
    color: 'red',
    skills: techStack.languages
  }
];